<section class="stc-premios">
  <div class="container-fluid">
    <div class="row">

    </div>
  </div>
</section>




<section class="content-aw">
  <div class="container">
    <div class="row">

      <div class="col-12 text-center">
        <h1 class="title">
          <span class="highlight">¡DÉJATE </span>
          <span class="outline">SORPRENDER </span>
          <br>
          <span class="highlight">CON SORTEO MAGNO!</span>
        </h1>
      </div>

      <div class="col-md-6 offset-md-1 text-md-right text-center">
        <img src="/assets/img/sorteo2025/premios/premio1.png" alt="Primer premio" class="img-fluid">
      </div>


      <div class="col-md-5 text-md-left text-center my-auto">
        <h3>Primer premio</h3>
        <p class="award-text">
          Departamento <span class="amueblado">amueblado</span> en Cancún
        </p>
        <p class="text-black">Valor más de 12,5 millones</p>
        <div class="mt-3">
          <p><span>Fecha del Sorteo: </span> <br> 20 de Noviembre 2025</p>
          <p><span>Sede:</span><br> Universidad Anáhuac Cancún</p>

          <div class="row mt-4">
            <div class="col-md-6">
              <img src="/assets/img/sorteo2025/premios/awards.png" class="img-fluid mt-3">
            </div>
            <div class="col-md-6">
              <img src="/assets/img/sorteo2025/premios/price.png" class="img-fluid mt-3">
            </div>
          </div>

          <button class="btn-stack mt-5">¡CÓMPRALO YA!</button>
        </div>
      </div>



      <div class="col-12 text-center bottom-award">
        <h4>
          DESCUBRE NUESTRAS NUEVAS
          SORPRESAS
        </h4>
        <p class="description mt-4">
          Más de <b>920 increíbles premios</b>! Exclusivas propiedades amuebladas,
          incluyendo un departamento en Cancún y otras 4 impresionantes ubicaciones.
          Además, tendrás la oportunidad de ganar el nuevo Kia K3 y productos Apple de última generación.
        </p>
      </div>


    </div>



  </div>
</section>






<section class="cta">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h5>
          <span>¡SÚMATE A</span> <br> SORTEO ANÁHUAC!
        </h5>

        <p>
          Y gana apoyando la educación de miles de
          alumnos de la Red de Universidades Anáhuac y
          creemos un mejor futuro para nuestro país.

        </p>
      </div>
    </div>
  </div>
</section>





<section class="stc-premios-list">
  <div class="container">
    <div class="row">


      <ng-container *ngIf="!isSmallScreen">
        <ng-container *ngFor="let image of premios; let i = index">
          <div *ngIf="i % 2 === 0" class="col-md-8">
            <div [id]="image.id" class="carousel slide" data-ride="false">
              <div class="carousel-inner">
                <div *ngFor="let img of image.imagenes; let first = first" class="carousel-item"
                  [ngClass]="{'active': first}">
                  <img [src]="img" class="d-block w-100" [alt]="image.title">
                </div>
              </div>
              <a class="carousel-control-prev" [href]="'#' + image.id" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </a>
              <a class="carousel-control-next" [href]="'#' + image.id" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>

          <div class="col-md-4 my-auto" [ngClass]="{'text-right': i % 2 !== 0}">
            <span class="number">{{ image.number }}</span>
            <h3 class="m-0">{{ image.title }}</h3>
            <h3 class="m-0"><strong>{{ image.subtitle }}</strong></h3>
            <p class="m-0">{{ image.place }}</p>
            <p class="m-0"><strong>{{ image.subplace }}</strong></p>
            <p class="m-0"><i>{{ image.price }}</i></p>
            <p>Precio del boleto: <span class="d-block strong">$500</span></p>

            <a class="btn-stack mt-3">¡COMPRA YA!</a>
          </div>

          <div *ngIf="i % 2 !== 0" class="col-md-8">
            <div [id]="image.id" class="carousel slide" data-ride="false">
              <div class="carousel-inner">
                <div *ngFor="let img of image.imagenes; let first = first" class="carousel-item"
                  [ngClass]="{'active': first}">
                  <img [src]="img" class="d-block w-100" [alt]="image.title">
                </div>
              </div>
              <a class="carousel-control-prev" [href]="'#' + image.id" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </a>
              <a class="carousel-control-next" [href]="'#' + image.id" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="isSmallScreen">
        <ng-container *ngFor="let image of premios; let i = index">
          <div class="col-12 col-md-4 my-auto">
            <span class="number" >{{ image.number }}</span>
            <h3 class="m-0">{{ image.title }}</h3>
            <h3 class="m-0"><strong>{{ image.subtitle }}</strong></h3>
            <p class="m-0">{{ image.place }}</p>
            <p class="m-0"><strong>{{ image.subplace }}</strong></p>
            <p class="m-0"><i>{{ image.price }}</i></p>
            <p>Precio del boleto: <span>$500</span></p>
            <a class="btn-stack mt-3">¡COMPRA YA!</a>
          </div>

          <div class="col-12 col-md-8">
            <div [id]="image.id" class="carousel slide" data-ride="false">
              <div class="carousel-inner">
                <div *ngFor="let img of image.imagenes; let first = first" class="carousel-item"
                  [ngClass]="{'active': first}">
                  <img [src]="img" class="d-block w-100" [alt]="image.title">
                </div>
              </div>
              <a class="carousel-control-prev" [href]="'#' + image.id" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </a>
              <a class="carousel-control-next" [href]="'#' + image.id" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div class="col-md-8 offset-md-2 text-center my-auto">
        <img src="/assets/img/sorteo2025/premios/premio6.png"  class="img-fluid mt-5" >
        <img src="/assets/img/sorteo2025/premios/premio7.png"  class="img-fluid mt-5" >
      </div>




    </div>
  </div>
</section>